var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.102 15.9836C17.7312 15.9836 17.3756 15.8433 17.1134 15.5938L12.5087 11.2119L7.9041 15.5938C7.77511 15.7209 7.62081 15.8222 7.45021 15.892C7.27962 15.9617 7.09613 15.9984 6.91046 16C6.7248 16.0015 6.54067 15.9678 6.36882 15.9009C6.19697 15.834 6.04085 15.7352 5.90956 15.6103C5.77826 15.4853 5.67444 15.3368 5.60413 15.1732C5.53382 15.0097 5.49844 14.8345 5.50005 14.6578C5.50167 14.4811 5.54024 14.3065 5.61352 14.1441C5.68681 13.9818 5.79334 13.835 5.92689 13.7122L11.5201 8.3896C11.7824 8.14014 12.138 8 12.5087 8C12.8795 8 13.2351 8.14014 13.4973 8.3896L19.0906 13.7122C19.2861 13.8983 19.4192 14.1354 19.4731 14.3935C19.5271 14.6516 19.4994 14.9191 19.3936 15.1622C19.2878 15.4053 19.1086 15.6131 18.8787 15.7593C18.6488 15.9055 18.3785 15.9836 18.102 15.9836Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.2081cb4475cdb3c25fd3ae1cb98ec7f9.svg";
export { ForwardRef as ReactComponent };